import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CancelCircleRegular from './cancel-circle-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CancelCircleRegular {...validProps} />;
}
SvgComponent.iconName = 'cancelCircleRegular';

export const CancelCircleRegularIcon = svgIconWrapper(SvgComponent);
